/**
 * Disable or enable cart in header.
 */
export default class DisableCartHeader {
  public static execute(numberProducts: number): void {
    const emptyCart: HTMLElement = document.querySelector(
      '.c-cartHeader__empty'
    );
    const cart: HTMLElement = document.querySelector('.c-cartHeader__list');
    const badge: HTMLElement = document.querySelector(
      '.c-menuTertiary__badge--cart'
    );
    const dot: HTMLElement = document.querySelector(
      '.c-menuTertiary__dot--cart'
    );

    if (numberProducts > 0) {
      cart.classList.add('is-enable');
      badge.classList.add('is-enable');
      dot.classList.add('is-enable');
      emptyCart.classList.remove('is-enable');
    } else if (numberProducts > 9) {
      badge.classList.add('c-menuTertiary__badge--large');
    } else {
      emptyCart.classList.add('is-enable');
      cart.classList.remove('is-enable');
      badge.classList.remove('is-enable');
      dot.classList.remove('is-enable');
    }
  }
}
